import { Card, Grid } from "antd";
import { useTranslation } from "react-i18next";
import { Title } from "../../components";
import { H6 } from "../../components/NormalFonts";
import { ContentWrapper } from "../../layouts/components";
import styles from "./styles.module.scss";
import "./styles.scss";

const Guide = () => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <ContentWrapper>
      <div
        className={`${styles.guide} ${screens.sm ? "" : styles.mobile} guide`}
      >
        <Title title={t("guide.title")} subtitle={t("guide.subtitle")} />
        <div
          className={styles.contentContainer}
          style={{ gap: screens.xs ? 16 : 24 }}
        >
          {Array.from({ length: 4 }, (_, i) => (
            <Card
              style={{ width: "100%" }}
              size={screens.sm ? "default" : "small"}
              title={
                <H6
                  className={styles.title}
                  color=" var(--text-content-1)"
                  weight="medium"
                >
                  {t(`guide.section${i + 1}.title`)}
                </H6>
              }
              variant="borderless"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: t(`guide.section${i + 1}.content`),
                }}
                className={`${styles.content}`}
              />
            </Card>
          ))}
        </div>
      </div>
    </ContentWrapper>
  );
};

export default Guide;
